import React, { useEffect } from "react";

export function LeaveScreen() {

  useEffect(() => {
    window.close();
  }, []);

  return (
    <div className="bg-gray-800 h-screen flex flex-col flex-1 items-center justify-center">
      <h1 className="text-white text-4xl">Call Ended</h1>
    </div >
  );
}
